import React, { useEffect, useState } from 'react';
import { Button, Modal, Popover, Space, Spin, Table } from 'antd';

import moment from 'moment';
import { useCreativeContext } from '../../../core/components/creatives/main/useCreativeContext';
import S3Image from '../CampaignLauncher/components/S3Image';
import { cloneDeep } from 'lodash';

// How many thumbnails show inline in the Gallery column before the "+N" popover
const GALLERY_INLINE_COUNT = 3;

const columns = [
  {
    title: 'Display Ad Group Name',
    dataIndex: 'name',
    key: 'name',
    ellipsis: true, // Enables ellipsis for text overflow
    width: 200, // Set a fixed width for the column
  },
  {
    title: 'Ad Units',
    dataIndex: 'medias',
    key: 'medias',
    render: (medias) => medias.length,
  },
  {
    title: 'Last Updated',
    dataIndex: 'updatedAt',
    key: 'updatedAt',
    render: (date) => moment(date).format('MM/DD/YYYY hh:mma'),
  },
  {
    title: 'Gallery',
    dataIndex: 'medias',
    key: 'medias',
    width: 220,
    render: (medias) => {
      const inline = medias.slice(0, GALLERY_INLINE_COUNT);
      const remaining = medias.length - inline.length;

      return (
        <Space size={4}>
          {inline.map((media, index) => (
            <S3Image key={index} imgKey={media.key} height={36} width={36} preview={false} />
          ))}
          {remaining > 0 && (
            <Popover
              title={`${medias.length} creatives`}
              trigger="click"
              content={
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(3, 72px)',
                    gap: 8,
                    maxHeight: 320,
                    overflowY: 'auto',
                  }}
                >
                  {medias.map((media, index) => (
                    <S3Image key={index} imgKey={media.key} height={72} width={72} />
                  ))}
                </div>
              }
            >
              <Button
                size="small"
                style={{ width: 36, height: 36, borderRadius: '50%', padding: 0 }}
              >
                +{remaining}
              </Button>
            </Popover>
          )}
        </Space>
      );
    },
  },
];

const CampaignRequestorAdGroupsDialog = ({
  visible,
  setVisible,
  orgId,
  onAddSelections,
  selectedAdGroupCreatives,
}) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const { fetchAdGroupCreatives, adGroupCreatives, loadingAdGroupCreatives } = useCreativeContext();

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const handleAddSelections = () => {
    if (selectedRowKeys.length === 0) {
      onAddSelections([]);
      setVisible(false);
      return;
    }
    const selectedAdGroup = cloneDeep(adGroupCreatives).filter((adGroup) =>
      selectedRowKeys.includes(adGroup.id)
    );
    onAddSelections(selectedAdGroup);
    setVisible(false);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  useEffect(() => {
    fetchAdGroupCreatives({
      variables: {
        where: {
          AND: [
            {
              org_some: {
                id: orgId,
              },
            },

            {
              org_every: {
                id: orgId,
              },
            },
            {
              medias_every: {
                type: 'STILL',
              },
            },
          ],
        },
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (selectedAdGroupCreatives && selectedAdGroupCreatives.length > 0) {
      const keys = [];
      selectedAdGroupCreatives.forEach((group) => {
        // Find the targeting group in the list by name
        const adGroup = adGroupCreatives.find((t) => t.name === group.name);
        if (adGroup) {
          keys.push(adGroup.id);
        }
      });
      setSelectedRowKeys(keys);
    }
  }, [adGroupCreatives, selectedAdGroupCreatives]);

  return (
    <>
      <Modal
        title={
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              paddingRight: 20,
            }}
          >
            <span>DISPLAY AD GROUPS</span>
            <div>
              <Button type="default" onClick={() => handleAddSelections()}>
                Add Selection(s)
              </Button>
            </div>
          </div>
        }
        visible={visible}
        onCancel={() => setVisible(false)}
        footer={null}
        width={1200}
      >
        {loadingAdGroupCreatives ? (
          <Space direction="vertical" style={{ width: '100%' }} align="center">
            <Spin />
          </Space>
        ) : (
          <Table
            rowKey="id"
            rowSelection={rowSelection}
            columns={columns}
            dataSource={adGroupCreatives}
          />
        )}
      </Modal>
    </>
  );
};

export default CampaignRequestorAdGroupsDialog;
